// extracted by mini-css-extract-plugin
module.exports = {"icon-close":"ModalHeader_icon-close__GzGA_","modal-heading":"ModalHeader_modal-heading__25A9D"};